// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'send-solid';

export const Component = () => (
  <path d='M4.203 13.007 1.546 22.5l21.954-10-22-10 2.704 9.585H16v.922H4.203Z' />
);

export const viewBox = '0 0 25 25';
